// extracted by mini-css-extract-plugin
export default {"overridesPrimaryDropdownDarkVariation":"PrimaryDropdownDarkVariation-module--overrides--PrimaryDropdownDarkVariation--C1tI9"};